export const COVID_SYMPTOMS = ['coronavirus', 'corona', 'covid', 'covid-19'];
